/**
 * type for the offline, to be used for tracking last synced x,y of map tiles
 */
export interface LastTileSyncDetails {
    lastSyncX: number;
    lastSyncY: number;
}